import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom card-stretch gutter-b"
  }, [_vm._m(0), _c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "codServico",
      "label-for": "codServico",
      "label": "Código serviço"
    }
  }, [_c('VueSelect', {
    class: {
      notFilled: _vm.servicoError
    },
    attrs: {
      "label": "codServico",
      "options": _vm.codServicoOptions,
      "filterable": false,
      "value": _vm.codServicoSelected,
      "placeholder": "Digite pela descrição"
    },
    on: {
      "input": _vm.setCodServico,
      "search": _vm.onSearchCodServico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.codigo, " - ").concat(option.descricao)) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.codigo, " - ").concat(option.descricao)) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição do serviço ")])], 2)], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "tributacao",
      "label-for": "tributacao",
      "label": "Tributação"
    }
  }, [_c('VueSelect', {
    class: {
      notFilled: _vm.tributacaoError
    },
    attrs: {
      "label": "tributacao",
      "options": _vm.tributacaoOptions,
      "filterable": false,
      "value": _vm.tributacaoSelected,
      "placeholder": "Digite pela descrição"
    },
    on: {
      "input": _vm.setTributacao,
      "search": _vm.onSearchTributacao
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.descricao)) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s("".concat(option.descricao)) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a descrição da tributação ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "discriminacao",
      "label-for": "discriminacao",
      "label": "Descrição"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.discriminacaoFilled,
      "autofocus": ""
    },
    model: {
      value: _vm.form.discriminacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "discriminacao", $$v);
      },
      expression: "form.discriminacao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração",
      "label-for": "duracao_minutos"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "duracao_minutos",
      "options": _vm.durationOptions,
      "state": _vm.durationFilled
    },
    model: {
      value: _vm.form.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "duracao_minutos", $$v);
      },
      expression: "form.duracao_minutos"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "deducao",
      "label-for": "versao_rtc",
      "label": "Gerar Dedução"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.deducao,
      expression: "form.deducao"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.deducao) ? _vm._i(_vm.form.deducao, null) > -1 : _vm.form.deducao
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.deducao,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "deducao", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "deducao", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "deducao", $$c);
        }
      }
    }
  }), _c('span')])])])], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacao",
      "maxlength": "254"
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "codigoTributacaoMunicipio",
      "label-for": "codigoTributacaoMunicipio",
      "label": "Cód. Tributação município"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.codigoTributacaoMunicipio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigoTributacaoMunicipio", $$v);
      },
      expression: "form.codigoTributacaoMunicipio"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "art",
      "label-for": "art",
      "label": "Art"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.art,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "art", $$v);
      },
      expression: "form.art"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "codigo_obra",
      "label-for": "codigo_obra",
      "label": "Cód. Obra"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.codigo_obra,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigo_obra", $$v);
      },
      expression: "form.codigo_obra"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "cei",
      "label-for": "cei",
      "label": "CEI"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autofocus": ""
    },
    model: {
      value: _vm.form.cei,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cei", $$v);
      },
      expression: "form.cei"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "valor",
      "label-for": "valor",
      "label": "Valor R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    style: !_vm.form.horimetro && _vm.valorFilled === false ? {
      border: '2px solid red'
    } : {},
    attrs: {
      "id": "valor",
      "name": "valor",
      "disabled": _vm.form.horimetro
    },
    model: {
      value: _vm.form.valor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor", $$v);
      },
      expression: "form.valor"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "horimetro",
      "label-for": "horimetro",
      "label": "Horímetro"
    }
  }, [_c('span', {
    staticClass: "switch switch-icon"
  }, [_c('label', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right",
      value: 'Não/Sim',
      expression: "'Não/Sim'",
      modifiers: {
        "hover": true,
        "right": true
      }
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.horimetro,
      expression: "form.horimetro"
    }],
    attrs: {
      "id": "horimetro",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.horimetro) ? _vm._i(_vm.form.horimetro, null) > -1 : _vm.form.horimetro
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.form.horimetro,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "horimetro", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "horimetro", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "horimetro", $$c);
        }
      }
    }
  }), _c('span')])])])], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor_hora",
      "label-for": "valor_hora",
      "label": "Valor hora R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    style: _vm.form.horimetro && _vm.valorHoraFilled === false ? {
      border: '2px solid red'
    } : {},
    attrs: {
      "id": "valor_hora",
      "name": "valor_hora",
      "disabled": !_vm.form.horimetro
    },
    model: {
      value: _vm.form.valor_hora,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valor_hora", $$v);
      },
      expression: "form.valor_hora"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1), _c('hr'), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "md-4"
    }
  }, [_c('h6', [_vm._v("Reforma Tributária")])])], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "md-2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cst",
      "label-for": "cst",
      "label": "Cód. CST"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "3"
    },
    model: {
      value: _vm.form.cst,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cst", $$v);
      },
      expression: "form.cst"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "col": "md-2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cct",
      "label-for": "cct",
      "label": "Cód. CCT"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "10"
    },
    model: {
      value: _vm.form.cct,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cct", $$v);
      },
      expression: "form.cct"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "nbs",
      "label-for": "nbs",
      "label": "Cód. NBS"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "15"
    },
    model: {
      value: _vm.form.nbs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nbs", $$v);
      },
      expression: "form.nbs"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "col": "md-2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "cct",
      "label-for": "codigoCreditoPresumido",
      "label": "Cód. Crédito Presumido"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "10"
    },
    model: {
      value: _vm.form.codigoCreditoPresumido,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigoCreditoPresumido", $$v);
      },
      expression: "form.codigoCreditoPresumido"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "col": "md-3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "codigoOperacao",
      "label-for": "codigoOperacao",
      "label": "Cód. indicador da operação"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "10"
    },
    model: {
      value: _vm.form.codigoOperacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "codigoOperacao", $$v);
      },
      expression: "form.codigoOperacao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "operacaoPessoal",
      "label-for": "operacaoPessoal",
      "label": "Operação Presencial"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "operacaoPessoal",
      "options": _vm.operacoesPessoal,
      "value-field": "value",
      "text-field": "descricao"
    },
    model: {
      value: _vm.form.operacaoPessoal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "operacaoPessoal", $$v);
      },
      expression: "form.operacaoPessoal"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tipoOperacao",
      "label-for": "tipoOperacao",
      "label": "Tipo de Operação GOV"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tipoOperacao",
      "options": _vm.tiposOperacao,
      "value-field": "value",
      "text-field": "descricao"
    },
    model: {
      value: _vm.form.tipoOperacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipoOperacao", $$v);
      },
      expression: "form.tipoOperacao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "tipoEnteGovernamental",
      "label-for": "tipoEnteGovernamental",
      "label": "Tipo Ente GOV"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "tipoEnteGovernamental",
      "options": _vm.tiposEnteGovernamental,
      "value-field": "value",
      "text-field": "descricao"
    },
    model: {
      value: _vm.form.tipoEnteGovernamental,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tipoEnteGovernamental", $$v);
      },
      expression: "form.tipoEnteGovernamental"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "nbm",
      "label-for": "nbm",
      "label": "Número Benefício Municipal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "maxlength": "20"
    },
    model: {
      value: _vm.form.nbm,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nbm", $$v);
      },
      expression: "form.nbm"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento Estadual"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.diferimentoPercentualEstadual,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "diferimentoPercentualEstadual", $$v);
      },
      expression: "form.diferimentoPercentualEstadual"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento Municipal"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.diferimentoPercentualMunicipal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "diferimentoPercentualMunicipal", $$v);
      },
      expression: "form.diferimentoPercentualMunicipal"
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "% Diferimento CBS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.diferimentoPercentualCBS,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "diferimentoPercentualCBS", $$v);
      },
      expression: "form.diferimentoPercentualCBS"
    }
  }, 'money', _vm.configMask, false))], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_novo_servico",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _vm.redirectOnSave ? _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'servicos'
      }
    }
  }, [_vm._v(" Cancelar ")]) : _c('button', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Novo serviço ")])])]);
}];
export { render, staticRenderFns };